import reducer from "./reducers";

import * as myDetailsOperations from "./operations";

export { myDetailsOperations };

export default reducer; 